(function (global, factory) {
  'use strict';
  var api = factory(global);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.EventsManifestCore = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function (runtime) {
  'use strict';

  var RFC3339 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;
  var SHOP_GID = /^gid:\/\/shopify\/Shop\/[1-9]\d*$/;
  var DISCOUNT_GID = /^gid:\/\/shopify\/DiscountAutomaticNode\/[1-9]\d*$/;
  var PRODUCT_GID = /^gid:\/\/shopify\/Product\/[1-9]\d*$/;
  var VARIANT_GID = /^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/;
  var HASH = /^[a-f0-9]{64}$/;
  var STORE_KEY = /^(?:dellamoda|ambrogio)$/;
  var EVENT_ID = /^promotion:(?:dellamoda|ambrogio):[A-Za-z0-9][A-Za-z0-9._:-]*$/;
  var MAX_VERIFICATION_TTL_MS = 15 * 60 * 1000;
  var REPAIR_RELEASE_ID = 'current-offers-recovery-20261022';
  var REPAIR_APPROVAL_REFERENCE = 'Sentinel_5a3fbc35f12c8191b18d2da5a42016ad+Sentinel_0a06c483e2348191a218c324a7127beb';
  var SUPERVISED_REPAIR_ID = 'current-offers-supervised-repair-20261022';
  var SUPERVISED_APPROVAL_REFERENCE = 'Sentinel_9c3d8ded13048191b41ca037672a39d4+Sentinel_6b03ecb5c8ac8191a06fec7c6259677c';
  var SUPERVISED_SNAPSHOTS = {
    dellamoda:{shopGid:'gid://shopify/Shop/14428994',offers:[
      ['promotion:dellamoda:2026-10:corrente-extra-20','gid://shopify/DiscountAutomaticNode/1533336355001','d0eb8f9c01380b0bc53e321fb00387960f902da9bff8c798310c1732fdff5510','2026-10-16T11:50:00Z','2026-10-23T04:00:00Z'],
      ['promotion:dellamoda:2026-10:tuzzi-extra-20','gid://shopify/DiscountAutomaticNode/1533410410681','48918f7359600f49680a30e51f3b756becfc600efd9597a3c96f29da040eb8ad','2026-10-17T04:00:00Z','2026-10-24T04:00:00Z'],
      ['promotion:dellamoda:2026-10:belvedere-chapo-50','gid://shopify/DiscountAutomaticNode/1533562257593','a1397b8c03bbe1704af5057dc41c65a6b1e896216763a3a5c6bdd58c0556f14d','2026-10-18T04:00:00Z','2026-10-25T04:00:00Z'],
      ['promotion:dellamoda:2026-10:emilio-franco-extra-30','gid://shopify/DiscountAutomaticNode/1533714366649','e917f81edf088268c0c1578c15374721bb7f94dbdd98fb08157b6360ed476fa2','2026-10-19T04:00:00Z','2026-10-26T04:00:00Z'],
      ['promotion:dellamoda:2026-10:jo-ghost-4970-50','gid://shopify/DiscountAutomaticNode/1533854384313','6859c2f281ba640c3accbd88c7f870a0d7af51aa7d0e2a3de44dbc086a1c4731','2026-10-20T04:00:00Z','2026-10-27T04:00:00Z'],
      ['promotion:dellamoda:2026-10:alexandria-wholecut-100','gid://shopify/DiscountAutomaticNode/1533955866809','be1e5bad1212372efc0d818a334c64b731c3d839d55ba7b6a4f5ad86fa15ae32','2026-10-21T04:00:00Z','2026-10-28T04:00:00Z']]},
    ambrogio:{shopGid:'gid://shopify/Shop/19187073124',offers:[
      ['promotion:ambrogio:2026-10:mauri-selected-15','gid://shopify/DiscountAutomaticNode/1818798031032','c8f716a162d08f52072d7083bc83e7486f731f0d542bad99a3487261ef3e9747','2026-10-16T04:00:00Z','2026-10-23T04:00:00Z'],
      ['promotion:ambrogio:2026-10:9899-suede-tassel-10','gid://shopify/DiscountAutomaticNode/1818985169080','dc7e67cf614019a6e0a07645b80c4809d2a5b499a9b5cb71033b206be10a69a1','2026-10-17T17:19:00Z','2026-10-24T04:00:00Z'],
      ['promotion:ambrogio:2026-10:black-patent-edit-10','gid://shopify/DiscountAutomaticNode/1818986610872','d4d758efb329131046e2bd71216a5546c71d34c6ecc548611d82ea0b073ffd6c','2026-10-18T04:00:00Z','2026-10-25T04:00:00Z'],
      ['promotion:ambrogio:2026-10:superglamourous-extra-35','gid://shopify/DiscountAutomaticNode/1819130101944','0adc5252165df79180de5dfc7e487008ee1c171b1685e1826cc2546d890def8b','2026-10-19T04:00:00Z','2026-10-26T04:00:00Z'],
      ['promotion:ambrogio:2026-10:jo-ghost-2727bis-50','gid://shopify/DiscountAutomaticNode/1819231420600','1948428a46c94a6bda83db8de8942419551e2bc2bebd57bbe2c2142b28c9b685','2026-10-20T04:00:00Z','2026-10-27T04:00:00Z'],
      ['promotion:ambrogio:2026-10:cesare-ostrich-150','gid://shopify/DiscountAutomaticNode/1819301478584','27f8d6560d4872d2520d66a37afa090015241d49e5280b6aab1cac9c607805f7','2026-10-21T04:00:00Z','2026-10-28T04:00:00Z']]}
  };

  function object(value) { return value !== null && typeof value === 'object' && !Array.isArray(value); }
  function instant(value) {
    if (typeof value !== 'string' || !RFC3339.test(value)) return null;
    var parts = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,3})?)?(?:Z|([+-])(\d{2}):(\d{2}))$/);
    if (!parts) return null;
    var year=Number(parts[1]),month=Number(parts[2]),day=Number(parts[3]),hour=Number(parts[4]),minute=Number(parts[5]),second=Number(parts[6] || 0);
    var offsetHour=Number(parts[8] || 0),offsetMinute=Number(parts[9] || 0);
    var daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
    if (month < 1 || month > 12 || day < 1 || day > daysInMonth || hour > 23 || minute > 59 || second > 59 || offsetHour > 23 || offsetMinute > 59) return null;
    var parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  function nonempty(value) { return typeof value === 'string' && value.trim().length > 0; }
  function stringArray(value, pattern, allowEmpty) {
    return Array.isArray(value) && (allowEmpty || value.length > 0) &&
      value.every(function (item) { return typeof item === 'string' && pattern.test(item); }) &&
      new Set(value).size === value.length;
  }
  function safeDestination(value) {
    if (typeof value !== 'string' || !/^\/(?!\/)/.test(value) || /[\\\u0000-\u0020\u007f]/.test(value) || /%(?:2f|5c)/i.test(value)) return false;
    try {
      var base = 'https://events.invalid';
      var parsed = new URL(value, base);
      return parsed.origin === base && parsed.username === '' && parsed.password === '' &&
        parsed.pathname + parsed.search + parsed.hash === value;
    } catch (_) { return false; }
  }
  function safeImage(value, storeKey) {
    if (typeof value !== 'string') return false;
    try {
      var url = new URL(value);
      var hosts = storeKey === 'dellamoda'
        ? ['cdn.shopify.com', 'dellamoda.com', 'www.dellamoda.com']
        : ['cdn.shopify.com', 'ambrogioshoes.com', 'www.ambrogioshoes.com'];
      return url.protocol === 'https:' && hosts.indexOf(url.hostname.toLowerCase()) >= 0 && url.username === '' && url.password === '';
    } catch (_) {
      return false;
    }
  }
  function sameInstant(a, b) {
    var left = instant(a); var right = instant(b);
    return left !== null && right !== null && left === right;
  }
  function stable(value) {
    if (Array.isArray(value)) return value.map(stable);
    if (object(value)) {
      var result = {};
      Object.keys(value).sort().forEach(function (key) { result[key] = stable(value[key]); });
      return result;
    }
    return value;
  }
  function stableStringify(value) { return JSON.stringify(stable(value)); }
  function sha256(value) {
    var bytes = new TextEncoder().encode(value);
    var bitLength = bytes.length * 8;
    var paddedLength = Math.ceil((bytes.length + 9) / 64) * 64;
    var padded = new Uint8Array(paddedLength);
    padded.set(bytes); padded[bytes.length] = 128;
    var view = new DataView(padded.buffer);
    view.setUint32(paddedLength - 8, Math.floor(bitLength / 0x100000000), false);
    view.setUint32(paddedLength - 4, bitLength >>> 0, false);
    var constants = [1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];
    var hash = [1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];
    var words = new Uint32Array(64);
    function rotate(value, count) { return value >>> count | value << (32 - count); }
    for (var offset = 0; offset < paddedLength; offset += 64) {
      for (var i = 0; i < 16; i += 1) words[i] = view.getUint32(offset + i * 4, false);
      for (var j = 16; j < 64; j += 1) {
        var s0 = rotate(words[j - 15], 7) ^ rotate(words[j - 15], 18) ^ words[j - 15] >>> 3;
        var s1 = rotate(words[j - 2], 17) ^ rotate(words[j - 2], 19) ^ words[j - 2] >>> 10;
        words[j] = (words[j - 16] + s0 + words[j - 7] + s1) >>> 0;
      }
      var a=hash[0],b=hash[1],c=hash[2],d=hash[3],e=hash[4],f=hash[5],g=hash[6],h=hash[7];
      for (var k = 0; k < 64; k += 1) {
        var e1 = rotate(e, 6) ^ rotate(e, 11) ^ rotate(e, 25);
        var choose = e & f ^ ~e & g;
        var t1 = (h + e1 + choose + constants[k] + words[k]) >>> 0;
        var a1 = rotate(a, 2) ^ rotate(a, 13) ^ rotate(a, 22);
        var majority = a & b ^ a & c ^ b & c;
        var t2 = (a1 + majority) >>> 0;
        h=g; g=f; f=e; e=(d+t1)>>>0; d=c; c=b; b=a; a=(t1+t2)>>>0;
      }
      hash[0]=(hash[0]+a)>>>0; hash[1]=(hash[1]+b)>>>0; hash[2]=(hash[2]+c)>>>0; hash[3]=(hash[3]+d)>>>0;
      hash[4]=(hash[4]+e)>>>0; hash[5]=(hash[5]+f)>>>0; hash[6]=(hash[6]+g)>>>0; hash[7]=(hash[7]+h)>>>0;
    }
    return hash.map(function (word) { return word.toString(16).padStart(8, '0'); }).join('');
  }
  function approvalPayload(value) {
    var payload = {
      eventId:value.eventId,storeKey:value.storeKey,shopGid:value.shopGid,campaignType:value.campaignType,
      startsAt:value.startsAt,endsAtExclusive:value.endsAtExclusive,nativeDiscountGid:value.nativeDiscountGid,
      nativeStartsAt:value.nativeStartsAt,nativeEndsAtExclusive:value.nativeEndsAtExclusive,
      eligibility:value.eligibility,discount:value.discount,presentation:value.presentation
    };
    ['nativeTerms','membershipSnapshot','priceBasis'].forEach(function(k){ if(value[k] !== undefined) payload[k]=value[k]; });
    return payload;
  }
  function eventContentHash(event) { return sha256(stableStringify(approvalPayload(event))); }
  function manifestContentHash(manifest) {
    var copy = JSON.parse(JSON.stringify(manifest)); delete copy.contentHash;
    return sha256(stableStringify(copy));
  }
  function validApprovalProvenance(raw, releaseMode) {
    var provenance = raw.approvalProvenance;
    if (!object(provenance)) return false;
    if (provenance.type === 'planner_approval') {
      return nonempty(provenance.planId) && provenance.exactVersionApprovalEstablished === true &&
        Number.isInteger(raw.planVersion) && raw.planVersion > 0 && raw.approvalTargetVersion === raw.planVersion &&
        HASH.test(raw.approvedContentHash || '');
    }
    if (provenance.type === 'reviewed_release') {
      return releaseMode === 'supervised_publication' &&
        (provenance.planId === null || nonempty(provenance.planId)) &&
        (raw.planVersion === null || (Number.isInteger(raw.planVersion) && raw.planVersion > 0)) &&
        raw.approvalTargetVersion === null && provenance.exactVersionApprovalEstablished === false &&
        /^[A-Za-z0-9][A-Za-z0-9._:+-]{0,255}$/.test(provenance.reviewedConfigurationId || '') &&
        Number.isInteger(provenance.reviewedConfigurationRevision) && provenance.reviewedConfigurationRevision > 0 &&
        /^[A-Za-z0-9][A-Za-z0-9._:+-]{0,255}$/.test(provenance.authorizationSourceReference || '') &&
        provenance.canonicalContentHash === raw.approvedContentHash;
    }
    if (provenance.type === 'supervised_repair') {
      return releaseMode === 'supervised_repair' &&
        (provenance.planId === null || nonempty(provenance.planId)) &&
        (raw.planVersion === null || (Number.isInteger(raw.planVersion) && raw.planVersion > 0)) &&
        raw.approvalTargetVersion === null && provenance.exactVersionApprovalEstablished === false &&
        provenance.supervisedRepairId === SUPERVISED_REPAIR_ID && provenance.supervisedRepairRevision === 1 &&
        provenance.ownerApprovalSourceReference === SUPERVISED_APPROVAL_REFERENCE &&
        provenance.canonicalContentHash === raw.approvedContentHash &&
        provenance.scope === 'restore_exact_unchanged_current_offer' && provenance.restoredExistingOffer === true &&
        provenance.economicTermsChanged === false && provenance.replacementOffer === false &&
        provenance.continuousNativeVerification === false && provenance.dailyManualReviewRequired === true &&
        provenance.earlyChangeRequiresManualCorrection === true;
    }
    return provenance.type === 'repair_release' &&
      (provenance.planId === null || nonempty(provenance.planId)) &&
      (raw.planVersion === null || (Number.isInteger(raw.planVersion) && raw.planVersion > 0)) &&
      raw.approvalTargetVersion === null && provenance.exactVersionApprovalEstablished === false &&
      provenance.repairReleaseId === REPAIR_RELEASE_ID && Number.isInteger(provenance.repairReleaseRevision) && provenance.repairReleaseRevision > 0 &&
      provenance.ownerApprovalSourceReference === REPAIR_APPROVAL_REFERENCE && HASH.test(provenance.canonicalContentHash || '') &&
      provenance.canonicalContentHash === raw.approvedContentHash &&
      provenance.scope === 'restore_unchanged_verified_existing_offer' && provenance.restoredExistingOffer === true &&
      provenance.economicTermsChanged === false && provenance.replacementOffer === false;
  }

  function normalizeEvent(raw, identity, now, releaseMode, published) {
    if (!object(raw) || !object(identity)) return null;
    if (!EVENT_ID.test(raw.eventId || '') || raw.eventId.indexOf('promotion:' + identity.storeKey + ':') !== 0) return null;
    if (raw.storeKey !== identity.storeKey || raw.shopGid !== identity.shopGid) return null;
    if (!HASH.test(raw.approvedContentHash || '') || raw.approvedContentHash !== eventContentHash(raw) || !validApprovalProvenance(raw, releaseMode) || raw.campaignType !== 'Event Promo') return null;
    var reusable = releaseMode === 'supervised_publication';
    var supervised = releaseMode === 'supervised_repair' || reusable;
    var enabled = raw.approvalStatus === 'approved' && raw.publicationStatus === 'ready' && raw.releaseState === 'live_verified';
    var revoked = supervised && raw.approvalStatus === 'approved' && raw.publicationStatus === 'disabled' && raw.releaseState === 'disabled';
    var queued = reusable && raw.approvalStatus === 'approved' && raw.publicationStatus === 'ready' && raw.releaseState === 'armed';
    if (!enabled && !revoked && !queued) return null;
    if (queued ? (raw.verificationStatus !== 'configuration_verified' || raw.nativeStatusAtVerification !== 'SCHEDULED') : (raw.verificationStatus !== 'checkout_verified' || raw.nativeStatusAtVerification !== 'ACTIVE')) return null;

    var start = instant(raw.startsAt); var end = instant(raw.endsAtExclusive);
    var verifiedAt = instant(raw.nativeVerifiedAt); var verificationExpires = instant(raw.verificationExpiresAt);
    if (start === null || end === null || start >= end || verifiedAt === null || verificationExpires === null || verifiedAt >= verificationExpires) return null;
    if (!Number.isFinite(now) || !Number.isFinite(published) || verifiedAt > published ||
        (!supervised && (verifiedAt > now || published >= verificationExpires)) ||
        (queued ? verifiedAt >= start : (verifiedAt < start || verifiedAt >= end)) || verificationExpires - verifiedAt > MAX_VERIFICATION_TTL_MS) return null;
    if (!sameInstant(raw.startsAt, raw.nativeStartsAt) || !sameInstant(raw.endsAtExclusive, raw.nativeEndsAtExclusive)) return null;
    if (!DISCOUNT_GID.test(raw.nativeDiscountGid || '')) return null;

    var eligibility = raw.eligibility;
    if (!object(eligibility) || !stringArray(eligibility.productGids, PRODUCT_GID, false)) return null;
    if (!['all_available', 'exact_ids'].includes(eligibility.variantMode)) return null;
    if (!stringArray(eligibility.variantGids, VARIANT_GID, true)) return null;
    if (eligibility.variantMode === 'exact_ids' && eligibility.variantGids.length === 0) return null;
    if (eligibility.variantMode === 'all_available' && eligibility.variantGids.length !== 0) return null;

    var discount = raw.discount;
    if (!object(discount) || !['fixed_cents', 'percent'].includes(discount.kind)) return null;
    if (!Number.isInteger(discount.value) || discount.value <= 0 || (discount.kind === 'percent' && discount.value >= 100)) return null;
    if (typeof discount.currency !== 'string' || !/^[A-Z]{3}$/.test(discount.currency) || typeof discount.nonStacking !== 'boolean') return null;

    var presentation = raw.presentation;
    if (!object(presentation)) return null;
    if (!['title', 'offerText', 'termsText', 'imageAlt', 'buttonLabel'].every(function (key) { return nonempty(presentation[key]); })) return null;
    if (!safeImage(presentation.imageUrl, identity.storeKey) || !safeDestination(presentation.destinationUrl)) return null;

    var normalized = {
      eventId: raw.eventId,
      storeKey: raw.storeKey,
      shopGid: raw.shopGid,
      startsAtMs: start,
      endsAtExclusiveMs: end,
      verificationExpiresAtMs: verificationExpires,
      supervisedRepair: supervised,
      revoked: revoked,
      nativeDiscountGid: raw.nativeDiscountGid,
      eligibility: {
        productGids: eligibility.productGids.slice(),
        variantMode: eligibility.variantMode,
        variantGids: eligibility.variantGids.slice()
      },
      discount: {
        kind: discount.kind,
        value: discount.value,
        currency: discount.currency,
        nonStacking: discount.nonStacking
      },
      presentation: {
        title: presentation.title,
        offerText: presentation.offerText,
        termsText: presentation.termsText,
        imageUrl: presentation.imageUrl,
        imageAlt: presentation.imageAlt,
        destinationUrl: presentation.destinationUrl,
        buttonLabel: presentation.buttonLabel
      }
    };
    if (reusable) normalized.queued = queued;
    if (raw.priceBasis !== undefined) normalized.priceBasis = JSON.parse(JSON.stringify(raw.priceBasis));
    return normalized;
  }

  function validSupervisedSnapshot(raw, published) {
    var snapshot = SUPERVISED_SNAPSHOTS[raw.storeKey]; var metadata = raw.supervisedRepair;
    if (!snapshot || snapshot.shopGid !== raw.shopGid || !Number.isInteger(raw.manifestVersion) || raw.manifestVersion < 3 ||
        raw.releaseId !== SUPERVISED_REPAIR_ID + '-' + raw.storeKey + '-r' + (raw.manifestVersion - 2) || !object(metadata)) return false;
    if (metadata.supervisedRepairId !== SUPERVISED_REPAIR_ID || metadata.supervisedRepairRevision !== 1 ||
        metadata.ownerApprovalSourceReference !== SUPERVISED_APPROVAL_REFERENCE ||
        metadata.certificationType !== 'point_in_time_native_configuration_and_checkout' ||
        metadata.continuousNativeVerification !== false || metadata.dailyManualReviewRequired !== true ||
        metadata.earlyChangeRequiresManualCorrection !== true || metadata.replacementOffersAllowed !== false ||
        raw.events.length !== snapshot.offers.length) return false;
    var expected = new Map(snapshot.offers.map(function (offer) { return [offer[0], offer]; }));
    for (var i = 0; i < raw.events.length; i += 1) {
      var event = raw.events[i]; var offer = object(event) ? expected.get(event.eventId) : null;
      if (!offer || event.nativeDiscountGid !== offer[1] || event.approvedContentHash !== offer[2] ||
          event.startsAt !== offer[3] || event.endsAtExclusive !== offer[4] ||
          !object(event.approvalProvenance) || event.approvalProvenance.type !== 'supervised_repair' || instant(event.startsAt) > published) return false;
      var enabled = event.approvalStatus === 'approved' && event.publicationStatus === 'ready' && event.releaseState === 'live_verified';
      var revoked = event.approvalStatus === 'approved' && event.publicationStatus === 'disabled' && event.releaseState === 'disabled';
      if (!enabled && !revoked) return false;
      expected.delete(event.eventId);
    }
    return expected.size === 0;
  }

  function readEnvelope(raw, identity, now, maxAgeMs) {
    if (object(raw) && raw.releaseMode === 'supervised_publication') {
      var reusable = typeof module === 'object' && module.exports ? require('./events-manifest-reusable') : runtime.EventsReusableManifest;
      if (!reusable || typeof reusable.readEnvelope !== 'function') return {ok:false,reason:'reusable_consumer_unavailable',events:[],rejected:[]};
      return reusable.readEnvelope(raw,identity,now,maxAgeMs,{instant:instant,sha256:sha256,stableStringify:stableStringify,manifestContentHash:manifestContentHash,normalizeEvent:normalizeEvent,supervisedSnapshots:SUPERVISED_SNAPSHOTS});
    }
    var rejected = [];
    if (!object(raw) || raw.schemaVersion !== 1 || !STORE_KEY.test(raw.storeKey || '') || !SHOP_GID.test(raw.shopGid || '')) {
      return { ok: false, reason: 'invalid_envelope', events: [], rejected: rejected };
    }
    if (!object(identity) || raw.storeKey !== identity.storeKey || raw.shopGid !== identity.shopGid) {
      return { ok: false, reason: 'wrong_store', events: [], rejected: rejected };
    }
    var releaseMode = raw.releaseMode || 'continuous_verification';
    if (releaseMode !== 'continuous_verification' && releaseMode !== 'supervised_repair') return { ok:false, reason:'invalid_release_mode', events:[], rejected:rejected };
    if (releaseMode !== 'supervised_repair' && raw.supervisedRepair !== undefined) return { ok:false, reason:'invalid_supervised_metadata', events:[], rejected:rejected };
    if (!Number.isInteger(raw.manifestVersion) || raw.manifestVersion < 1 || !nonempty(raw.releaseId) || !HASH.test(raw.contentHash || '')) {
      return { ok: false, reason: 'invalid_release', events: [], rejected: rejected };
    }
    var published = instant(raw.publishedAt);
    if (published === null || !raw.publishedAt.endsWith('Z') || !Number.isFinite(now) || !Number.isFinite(maxAgeMs) || maxAgeMs <= 0) {
      return { ok: false, reason: 'invalid_freshness', events: [], rejected: rejected };
    }
    if (published > now + 5 * 60 * 1000 || (releaseMode !== 'supervised_repair' && now - published > maxAgeMs)) {
      return { ok: false, reason: 'stale_release', events: [], rejected: rejected };
    }
    if (!Array.isArray(raw.events)) return { ok: false, reason: 'invalid_events', events: [], rejected: rejected };
    if (manifestContentHash(raw) !== raw.contentHash) return { ok: false, reason: 'content_hash_mismatch', events: [], rejected: rejected };
    if (releaseMode === 'supervised_repair' && !validSupervisedSnapshot(raw, published)) return { ok:false, reason:'invalid_supervised_snapshot', events:[], rejected:rejected };

    var normalized = raw.events.map(function (entry) { return normalizeEvent(entry, identity, now, releaseMode, published); });
    var eventCounts = new Map(); var discountCounts = new Map();
    normalized.forEach(function (entry) {
      if (!entry) return;
      eventCounts.set(entry.eventId, (eventCounts.get(entry.eventId) || 0) + 1);
      discountCounts.set(entry.nativeDiscountGid, (discountCounts.get(entry.nativeDiscountGid) || 0) + 1);
    });
    var events = [];
    normalized.forEach(function (entry, index) {
      if (!entry || eventCounts.get(entry.eventId) !== 1 || discountCounts.get(entry.nativeDiscountGid) !== 1) rejected.push(index);
      else events.push(entry);
    });
    if (releaseMode === 'supervised_repair' && (rejected.length || events.length !== raw.events.length)) {
      return { ok:false, reason:'invalid_supervised_event', events:[], rejected:rejected };
    }
    var releaseExpiresAtMs = releaseMode === 'supervised_repair'
      ? Math.max.apply(null, events.map(function (event) { return event.endsAtExclusiveMs; }))
      : published + maxAgeMs;
    return {
      ok: true,
      reason: null,
      events: events,
      rejected: rejected,
      manifestVersion: raw.manifestVersion,
      releaseId: raw.releaseId,
      publishedAtMs: published,
      releaseExpiresAtMs: releaseExpiresAtMs,
      releaseMode: releaseMode
    };
  }

  function active(event, now) {
    return object(event) && event.revoked !== true && event.queued !== true && Number.isFinite(now) && now >= event.startsAtMs && now < event.endsAtExclusiveMs &&
      (event.supervisedRepair === true || now < event.verificationExpiresAtMs);
  }
  function numericGid(value, prefix) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) return null;
    var text = String(value);
    var bare = /^[1-9]\d*$/.test(text) ? text : null;
    if (bare) return prefix + bare;
    var full = prefix === 'gid://shopify/Product/' ? PRODUCT_GID : VARIANT_GID;
    return full.test(text) ? text : null;
  }
  function productGid(value) { return numericGid(value, 'gid://shopify/Product/'); }
  function variantGid(value) { return numericGid(value, 'gid://shopify/ProductVariant/'); }
  function eligible(event, input) {
    if (!object(event) || !object(input) || input.available !== true) return false;
    var productByGid = input.productGid === undefined ? null : productGid(input.productGid);
    var productById = input.productId === undefined ? null : productGid(input.productId);
    var variantByGid = input.variantGid === undefined ? null : variantGid(input.variantGid);
    var variantById = input.variantId === undefined ? null : variantGid(input.variantId);
    if ((input.productGid !== undefined && !productByGid) || (input.productId !== undefined && !productById) ||
        (input.variantGid !== undefined && !variantByGid) || (input.variantId !== undefined && !variantById)) return false;
    if (productByGid && productById && productByGid !== productById) return false;
    if (variantByGid && variantById && variantByGid !== variantById) return false;
    var product = productByGid || productById;
    var variant = variantByGid || variantById;
    if (event.priceBasis && event.priceBasis.kind === 'exact_variant_prices') {
      var certified = event.priceBasis.variantPrices.find(function(v){return v.variantGid === variant && v.productGid === product;});
      if (!certified || certified.priceCents !== input.priceCents) return false;
    }
    if (!product || !variant || event.eligibility.productGids.indexOf(product) < 0) return false;
    return event.eligibility.variantMode === 'all_available' || event.eligibility.variantGids.indexOf(variant) >= 0;
  }
  function savings(event, priceCents, presentmentCurrency) {
    if (!Number.isFinite(priceCents) || priceCents < 0 || !Number.isInteger(priceCents)) return null;
    if (event.discount.kind === 'fixed_cents' && event.discount.currency !== presentmentCurrency) return null;
    return event.discount.kind === 'fixed_cents' ? Math.min(priceCents, event.discount.value) : Math.round(priceCents * event.discount.value / 100);
  }
  function choose(events, input, now, presentmentCurrency, releaseExpiresAtMs) {
    if (!Array.isArray(events) || !object(input) || !Number.isFinite(now) || typeof presentmentCurrency !== 'string' || !Number.isFinite(releaseExpiresAtMs) || now >= releaseExpiresAtMs) return null;
    var candidates = [];
    events.forEach(function (event) {
      if (!active(event, now) || !eligible(event, input)) return;
      var saved = savings(event, input.priceCents, presentmentCurrency);
      if (saved === null) return;
      candidates.push({ event: event, saved: saved });
    });
    candidates.sort(function (a, b) {
      return b.saved - a.saved || a.event.endsAtExclusiveMs - b.event.endsAtExclusiveMs || a.event.eventId.localeCompare(b.event.eventId);
    });
    return candidates.length ? candidates[0] : null;
  }

  return {
    active: active,
    choose: choose,
    eligible: eligible,
    instant: instant,
    normalizeEvent: normalizeEvent,
    eventContentHash: eventContentHash,
    manifestContentHash: manifestContentHash,
    readEnvelope: readEnvelope,
    safeDestination: safeDestination,
    supervisedSnapshots: SUPERVISED_SNAPSHOTS,
    savings: savings,
    sha256: sha256,
    stableStringify: stableStringify,
    validSupervisedSnapshot: validSupervisedSnapshot
  };
}));
